module.exports = __webpack_public_path__ + "img/trophy-awards.38a2f3b4.svg";